import bn from 'bignumber.js';

const MAXIMUM_AUCTION_DURATION = (6 * 60 * 60);

export default ({ timer, serviceFactory, auctionContract, erc20Contract, network, config }) => (optionAddress) => {

  if (!optionAddress) {
    return serviceFactory({
      name: 'empty-auction',
      subscribe: update => {
        update({
          current: {},
          next: {}
        });
        return () => {}
      }
    });
  }

  return serviceFactory({
    name: 'auction-service',
    subscribe: (update) => {
      update({
        current: {},
        next: {}
      }, true)
      //start with polling, but eventually this should be driven by events
      return timer.periodic('auction-service', 1000, async () => {
        const auction = await auctionContract.deployed();
        const net = await network.get();
        const currencyAddress = config.auctionService.currency[net.network];
        const [optionDecimals, currencyDecimals] = await Promise.all([(await erc20Contract.at(optionAddress)).decimals(), (await erc20Contract.at(currencyAddress)).decimals()]);
        const [round, running, startTime, startNumerator, startDenominator, quantityTarget, quantityCurrency] = await auction.currentRound(optionAddress, currencyAddress);
        //        const stuff = await auction.currentEnd(optionAddress, currencyAddress);
        //        console.log(stuff.map(x => x.toString()));
        const [nextRound, nextStart, nextPriceNumerator, nextPriceDenominator, nextQuantity] = await auction.nextRound(optionAddress, currencyAddress);
        const offset = Math.floor(Date.now() / 1000) - Number(startTime);
        const targetNumerator = bn(startNumerator);
        const targetDenominator = bn(startDenominator).times(2);
        const endPriceWithBid = bid => {
          if (!bn(quantityCurrency).plus(bn(bid)).gt(bn(0))) return null;
          const atomic = bn(bid).times(bn(10).pow(+currencyDecimals));
          const newEndPrice = price(bn(quantityCurrency).plus(atomic), quantityTarget);
          return newEndPrice.gt(current()) ? current() : newEndPrice;
        }
        const endPrice = endPriceWithBid(0);
        const buyoutPrice = (quantityTarget && current()) ? 
        bn(quantityTarget).div(bn(10).pow(+optionDecimals)).times(current())
        .minus(bn(quantityTarget).div(bn(10).pow(+optionDecimals)).times(endPrice || bn(0))) : bn(0);
        const buyoutAmount = current() ? buyoutPrice.div(current()) : bn(0);

        function fromAtomic(atomic, decimals) {
          return bn(atomic).div(bn(10).pow(Number(decimals)));
        }

        function price(numerator, denominator) {
          return fromAtomic(numerator, currencyDecimals).div(fromAtomic(denominator, optionDecimals));
        }

        function end() {
          let offset = bn(MAXIMUM_AUCTION_DURATION).times(bn(2).times(quantityTarget).times(targetNumerator).minus(bn(quantityCurrency).times(targetDenominator)).div(bn(2).times(bn(quantityTarget).times(targetNumerator).plus(bn(quantityCurrency).times(targetDenominator))))).integerValue();
          return Number(startTime) + Number(offset) + 1;
        }

        function priceAt(offset) {
          if (offset >= MAXIMUM_AUCTION_DURATION) {
            return 0;
          }
          var currentNumerator = bn(targetNumerator).times(MAXIMUM_AUCTION_DURATION - offset);
          var currentDenominator = bn(targetDenominator).times(offset + MAXIMUM_AUCTION_DURATION / 2);
          if (currentNumerator.times(bn(quantityTarget)).gt(bn(quantityCurrency).times(currentDenominator))) {
            return price(currentNumerator, currentDenominator);
          } else {
            return price(quantityCurrency, quantityTarget);
          }
        }

        function current() {
          return priceAt(offset);
        }

        function priceCurve() {
          var data = [];
          if (startTime > 0) {
            var stopTime = Number(end()) - Number(startTime);
            for (var offset = 0; offset <= stopTime; offset += 10 * 60) {
              data.push({
                price: Number(priceAt(offset)),
                offset
              })
            }
          }
          //          console.log(data.map(d => d.price.toString() + " @ " + d.offset))
          return data;
        }

        function buy(amountCurrency) {
          const atomicCurrency = bn(amountCurrency).times(bn(10).pow(+currencyDecimals));
          console.log("Buying:", atomicCurrency.toString());
          auction.buy(optionAddress, currencyAddress, atomicCurrency.toString());
        }

        update({
          auctionAddress: auction.address,
          optionAddress,
          currencyAddress,
          current: startTime > 0 ? {
            running,
            round,
            startTime,
            offset,
            endTime: end(),
            quantityTarget,
            quantityCurrency,
            startPrice: price(startNumerator, startDenominator),
            currentPrice: current(),
            buyoutPrice,
            buyoutAmount,
            endPrice,
            endPriceWithBid,
            priceAt,
            priceCurve,
            buy
          } : {},
          next: nextStart > 0 ? {
            round: nextRound,
            startTime: nextStart,
            startPrice: price(nextPriceNumerator, nextPriceDenominator),
            quantityTarget: nextQuantity
          } : {}
        })
      })
    }
  })
}


// WEBPACK FOOTER //
// ./src/api/auction-service.js